<template>
  <div>
    <div class="overlayPopBg"></div>
    <div class="indpendent-content">
      <span class="popClose" @click="modelclose()">
        <i class="material-icons">
          close
        </i>
      </span>
      <div class="innerindpendent">
        <div class="innerBox">
          <div class="logo-box">
            <img src="../assets/images/indipendentday-logo.png" />
            <span class="winicon">
              <img src="../assets/images/winnerIcon.png" />
            </span>
          </div>

          <div class="dtlcontexBox">
            <div class="eventPrgpanel">
              <h2>{{ $t('EventEnd') }}</h2>
              <div class="eventCountbox">
                <div
                  class="count_col"
                  v-for="(data, key) in timerLeft.response"
                >
                  <span class="text_title">{{ key }}</span>
                  <span class="counter_val">{{ data }}</span>
                </div>
              </div>
              <h2>यह इवेंट मनी 91 के users के लिए है।</h2>
            </div>

            <div class="giftpanel">
              <h2>टॉप १० लोगो को मिलेंगे</h2>
              <span class="priceBtntext">₹1000</span>
              <h2>मूल्य के नकद पुरस्कार |</h2>
            </div>

            <div class="innerBox rulescnt">
              <h2>आपको पॉइंट्स मिलने के मापदंड है</h2>
              <ul>
                <li>की आप कितने देर लाइव जाते हैं।</li>
                <li>आपके लाइव से कितने लोग जुड़ते है।</li>
                <li>आपके लाइव पे कितने लोग कमेंट करते हैं।</li>
                <li>आपको लोग कितने हर्ट्स भेजते है।</li>
              </ul>
            </div>

            <div class="innerBox">
              <span class="starIcon">*</span>
              <p>विनिंग अमाउंट आपके मनी 91 वॉलेट में क्रेिडट कर दिया जायेगा।</p>
              <p>
                धोखाधड़ी या अनुिचत साधनों का उपयोग करते हुए अंक अर्जित करने के
                लिए अयोग्य घोषित और प्रतिबंधित कर दिया जाएगा।
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Timer } from '../utils/helper'
import Vue from 'vue'

export default {
  name: 'LeaderBoardTimer',
  props: { intervalTimer: Number, timerLeft: Object },

  watch: {
    timerLeft: (newVal, oldVal) => {
      console.log('=newVal===', newVal.off)
      if (newVal && newVal.off) {
        try {
          window.clearInterval(window._intervalTimer)
          document.querySelector('body').classList.remove('popbody')
        } catch (err) {
          console.log('---', err)
        }
        window._intervalTimerToogle = false
      } else {
        console.log('===else')
      }
    }
  },
  methods: {
    modelclose() {
      document.querySelector('body').classList.remove('popbody')
      try {
        window.clearInterval(window._intervalTimer)
      } catch (err) {
        console.log('---', err)
      }
    }
  }
}
</script>
